import { Head, Link } from '@inertiajs/react'
import SalesminerAppLayout from "@/salesminer/layouts/SalesminerAppLayout.tsx";

interface User {
    name: string
    email: string
}

interface Organization {
    name: string
    slug: string
}


interface Account {
    name: string
}

interface Props {
    user: User
    organization: Organization
    accounts: Account[]
}

export default function Index({user, organization, accounts}: Props) {
    return (
        <SalesminerAppLayout>
            <Head title={`Dashboard - ${organization.name} - SalesMinr`}/>
            <div className="p-6">
                {/* Page Header */}
                <div className="mb-6">
                    <div className="flex justify-between items-center">
                        <div>
                            <h1 className="text-3xl font-extrabold text-neutral-900 dark:text-neutral-50">
                                Dashboard
                            </h1>
                            <p className="text-neutral-600 dark:text-neutral-300 mt-1">
                                Welcome back, {user.name}
                            </p>
                        </div>

                        <div className="flex items-center space-x-4">
                            <Link href={`/~/${organization.slug}/session`} method="delete" as="button"
                                  className="bg-error-600 hover:bg-error-700 text-white px-4 py-2 rounded text-sm font-medium transition-colors">
                                Logout
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="border-4 border-dashed border-neutral-200 dark:border-neutral-600 rounded-lg p-8">
                    <div className="text-center">
                        <h2 className="text-3xl font-bold text-neutral-900 dark:text-neutral-50 mb-4">
                            🎉 Authentication Working!
                        </h2>

                        <div
                            className="bg-success-50 dark:bg-success-900/20 border border-success-200 dark:border-white rounded-md p-6 text-left max-w-md mx-auto">
                            <h3 className="text-lg font-semibold text-success-800 dark:text-white mb-3">
                                Successful Login Details:
                            </h3>
                            <dl className="space-y-2">
                                <div>
                                    <dt className="text-sm font-medium text-success-600 dark:text-gray-300">User:</dt>
                                    <dd className="text-sm text-success-800 dark:text-white">{user.name} ({user.email})</dd>
                                </div>
                                <div>
                                    <dt className="text-sm font-medium text-success-600 dark:text-gray-300">Organization:</dt>
                                    <dd className="text-sm text-success-800 dark:text-white">{organization.name}</dd>
                                </div>
                                <div>
                                    <dt className="text-sm font-medium text-success-600 dark:text-gray-300">Accounts
                                        Count:
                                    </dt>
                                    <dd className="text-sm text-success-800 dark:text-white">{accounts.length}</dd>
                                </div>
                                <div>
                                    <dt className="text-sm font-medium text-success-600 dark:text-gray-300">URL:</dt>
                                    <dd className="text-sm text-success-800 dark:text-white">/~/{organization.slug}/dashboard</dd>
                                </div>
                                <div>
                                    <dt className="text-sm font-medium text-success-600 dark:text-gray-300">Tenant
                                        Context:
                                    </dt>
                                    <dd className="text-sm text-success-800 dark:text-white">✅ Set correctly</dd>
                                </div>
                            </dl>
                        </div>

                        <div className="mt-8 text-neutral-600 dark:text-neutral-300">
                            <p>This is a placeholder dashboard for Phase 2 testing.</p>
                            <p className="mt-2">Phase 3 will add proper tenant-aware routing and features.</p>
                        </div>
                    </div>
                </div>
            </div>
        </SalesminerAppLayout>
    )
}